import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataSource} from '@angular/cdk/table';
import {IDesignSolution, InfoToShow} from "../../../models/common";
import {Utils} from "../../../common/utils";
import {isNullOrUndefined} from "util";
import {BehaviorSubject, Observable} from "rxjs";

@Component({
  selector: 'edsng-design-table',
  templateUrl: './design-table.component.html',
  styleUrls: ['./design-table.component.css']
})
export class DesignTableComponent implements OnInit {

  private static _displayedColumnsInfo = [
    {label:'Part Number', field:'partNumber'}
    , {label:'Package', field:'packageName'}
    ];

  displayedColumnsInfo = DesignTableComponent._displayedColumnsInfo;

  get displayedColumns(){
    return this.displayedColumnsInfo.map(({field})=>field);
  }

   _LocalDb: BehaviorSubject<IDesignSolution[]> = new BehaviorSubject<IDesignSolution[]>([]);

  @Input() db: BehaviorSubject<IDesignSolution[]> = new BehaviorSubject<IDesignSolution[]>([]);
  @Output() selectedItem: EventEmitter<IDesignSolution> = new EventEmitter<IDesignSolution>();
  dataSource: DesignSolutionDataSource | null;
  _selectedItem: IDesignSolution = null;
  @Input() topology: string | null;

  constructor() {  }

  ngOnInit() {
    this.dataSource = new DesignSolutionDataSource(this._LocalDb);

    this.db.subscribe((y:IDesignSolution[])=>{
      const _dbLocal = y.filter(a=>a.topology === this.topology);
      this._LocalDb.next(_dbLocal);
      if (this.displayedColumnsInfo === DesignTableComponent._displayedColumnsInfo) {
        const _showInfos =  _dbLocal.map(({shownInfo}) => shownInfo).reduce((acc:InfoToShow[],x)=>{return acc.concat(x)},[])   //get shownInfo data from all IDesignSolution
                  //remove duplicate
                .reduce<InfoToShow[]>((acc: InfoToShow[], cur: InfoToShow) => {
                    const item = acc.find((val) => val.dataName.label === cur.dataName.label);
                    return  (!isNullOrUndefined(item) && item.dataName.label === cur.dataName.label || cur.dataName.label === '') ? acc : acc.concat(cur)
                }, []);
//        console.log("show info", _showInfos);
        let _showOtherInfo = [];
          if (!isNullOrUndefined(_showInfos) && _showInfos.length >=1) {
            _showOtherInfo = _showInfos //get shownInfo data from the first IDesignSolution
              .map(((x, i) => {
                const lbl = x.dataName.label.replace(":", "");
                return {
                  label: lbl + (x.dataName.unit !== "" ? " (" + x.dataName.unit + ")" : "" ),
                  field: 'shownInfo.' + lbl, //'shownInfo.' + i + '.dataName.value'
                }
              }));
          }
        this.displayedColumnsInfo = DesignTableComponent._displayedColumnsInfo.concat(_showOtherInfo);
      }
      // console.log("Test ", this.displayedColumnsInfo);
    })
  }

  selectRow(row:IDesignSolution){

    if (this._selectedItem && this._selectedItem === row)
      this._selectedItem = null; //deselect
    else
      this._selectedItem = row;
    this.selectedItem.emit(this._selectedItem);
  }

  getField(row:IDesignSolution, label:string):string{
    // console.log("Test ---->", row, label);
    // console.log(label);
    if (label.startsWith('shownInfo.')){

      const infos:InfoToShow[] = Utils.getFieldValue(row, 'shownInfo', []);
      const field = label.replace('shownInfo.', '')+':';
      const info = infos.find(x=>x.dataName.label===field);
      //console.log('Temp ', infos, field, info);
      if (!isNullOrUndefined(info)){
        return info.dataName.value;
      }

    } else
      return Utils.getFieldValue(row, label, 'N.A.');

    return 'N.A.';
  }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, UserFileDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
class DesignSolutionDataSource extends DataSource<any> {
  constructor(private db: BehaviorSubject<IDesignSolution[]>) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<IDesignSolution[]> {
    return this.db;
  }

  disconnect() {}
}
